const GTAG_ID = 'UA-27210162-11';

const addTagManager = (w: Window, d: Document, s: string, l: string, i: string) => {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s) as HTMLScriptElement,
    // eslint-disable-next-line eqeqeq
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode!.insertBefore(j, f);
};

const addScript = () => {
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  script.async = true;
  document.body.appendChild(script);
};

function gtag(key: string, value: any) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export const addGTag = () => {
  addTagManager(window, document, 'script', 'dataLayer', 'GTM-MMS4MM3');
  addScript();
  gtag('js', new Date());
  gtag('config', GTAG_ID);
};
